import React, { memo, useEffect, useState } from 'react'
import cx from 'classnames'
import { PrismicRichText } from '@prismicio/react'
import Icon from 'components/shared/Icon'
import useNewsTickerItems from 'hooks/useNewsTickerItems'

const tickerTime = 3000
const tickLength = 30

const NewsTickerDesktop = ({ CMS_DATA }) => {
  const [active, setActive] = useState(0)
  const [timer, setTimer] = useState()
  const [timeLeft, setTimeLeft] = useState(tickerTime)
  const { newsItems } = useNewsTickerItems({ CMS_DATA })

  useEffect(() => {
    // Callback for the timer
    const timerTickCallback = () => {
      const newTimeLeft = timeLeft - tickLength

      if (newTimeLeft <= 0) {
        setActive((active + 1) % newsItems.length)
        setTimeLeft(tickerTime)
      } else {
        setTimeLeft(newTimeLeft)
      }
    }
    const timeout = setTimeout(timerTickCallback, tickLength)
    setTimer(timeout)
    return () => clearTimeout(timeout)
  }, [timeLeft])

  const handlePrevious = () => {
    clearTimeout(timer)
    setTimeLeft(tickerTime)
    setActive((active + newsItems.length - 1) % newsItems.length) // makes sure active is always positive
  }

  const handleNext = () => {
    clearTimeout(timer)
    setTimeLeft(tickerTime)
    setActive((active + 1) % newsItems.length)
  }

  if (!newsItems) return null

  return (
    <div className='w-100 h-100' data-testid='news-ticker'>
      <NewsItems newsItems={newsItems} active={active} />
      <div className='absolute right0 top4 z15'>
        <button className='ma0 pa0 bg-transparent grey hover-black pointer' onClick={handlePrevious} data-testid='news-prev'>
          <Icon name='icon-chevron-left' className='w7' />
        </button>
        <button className='ma0 pa0 bg-transparent grey hover-black pointer' onClick={handleNext} data-testid='news-next'>
          <Icon name='icon-chevron-right' className='w7' />
        </button>
      </div>
    </div>
  )
}

const NewsItems = memo(({ newsItems, active }) => {
  const positionChecker = (idx) => {
    if (active === newsItems.length - 1 && idx === 0) {
      return 1
    }
    if (active === 0 && idx === newsItems.length - 1) {
      return -1
    }

    return idx - active
  }

  return newsItems.map((newsEntry, idx) => {
    const position = positionChecker(idx)
    return (
      <div
        className={cx(
          'flex items-center absolute right0 left0 top0 bottom0 pl4 pr9 transition-all',
          {
            'y--100 o-0': position < 0,
            'y-100 o-0': position > 0,
            z5: position === 0
          })}
        key={idx}
        data-testid='news-item'
        data-news-index={idx}
      >
        <PrismicRichText field={newsEntry} />
      </div>
    )
  })
})

export default NewsTickerDesktop
